module.exports = __webpack_public_path__ + "img/nosub.b6df1a51.png";